import L from 'leaflet';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

// Leaflet's default marker icon breaks under bundlers (Vite). Two parts:
// 1. L.Icon.Default._getIconUrl prepends L.Icon.Default.imagePath to the icon
//    URL. With a full bundled asset URL that produces a doubled, 404 path, so
//    the override must be removed before our URLs are used.
// 2. Point the default icon at the bundled asset URLs.
// Side-effect module: import once at page entry.
delete (L.Icon.Default.prototype as unknown as { _getIconUrl?: unknown })._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});
